import { render, staticRenderFns } from "./PedidosPendente.vue?vue&type=template&id=f3c9a77a"
import script from "./PedidosPendente.vue?vue&type=script&lang=js"
export * from "./PedidosPendente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports